module.exports = __webpack_public_path__ + "img/lucy-stone.4aa66cc9.png";